import { createSelector } from "@ngrx/store";


export const getLanguagesList = createSelector(
    (state: any) => state.languages,
    (state: any) => state.get('languagesList')
)